"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeRoles_en_us = void 0;
function backofficeRoles_en_us() {
    return {
        "errors.roles.userremaininginrole": "The role still includes one or more users. Remove all users from the role in order to delete it.",
        "errors.roles.lastroleofuser": "You are removing the user from his last role within this tenant. Doing so will remove the user from the project/company.",
        "errors.roles.wrongtenanttype": "TenantType must be 'project' or 'company'.",
        "errors.roles.usernotpartoftenant": "User is not part of this tenant.",
        "errors.roles.deletinglastadmin": "The last Admin is being removed from the project. Assign a different users to an admin role or delete the project.",
        "backoffice.roles.noroles.menuerror": "No roles found",
        "backoffice.roles.noroles.headline": "Create a role",
        "backoffice.roles.noroles.message": "Start creating roles for your employees or colleagues if you see the need for distinct permissions! If you're the only one in this project, you normally don't need to create any roles.",
        "backoffice.roles.createnew": "Create new role",
        "backoffice.roles.editrole": "Edit role",
        "backoffice.roles.name": "Name",
        "backoffice.roles.description": "Description",
        "backoffice.roles.numberroleowners": "Number of role owners",
        "backoffice.roles.permissions": "Permissions",
        "backoffice.roles.hints.description": "Description of the role",
        "backoffice.roles.hints.name": "Name of role",
        "backoffice.roles.deletiondialog.title": "Confirm role deletion",
        "backoffice.roles.deletiondialog.message": "Do you really want to delete the role \"${roleName}\"?",
        "backoffice.roles.deletiondialog.deleteallroleusers": "All employees within the role must first be removed before it can be deleted.",
        "backoffice.roles.errors.rolenotfound": "Role not found!",
        "backoffice.roles.errors.noadmin": "At least one role with the permission 'tenant.admin' must exist. At least one user must be assigned to this role!"
    };
}
exports.backofficeRoles_en_us = backofficeRoles_en_us;
